// extracted by mini-css-extract-plugin
export default {"card":"PlanCard_card__IQcAC","selectable":"PlanCard_selectable__tqAY7","selected":"PlanCard_selected__HJG6p"};